module.exports = __webpack_public_path__ + "static/media/kr-share-image.cf148de4.jpg";